import { observer } from 'mobx-react-lite'
import type { SelectionState } from '@/infra/selection-state'
import { match } from '@/utils/pattern-match-util'
import { type ApplicantManagementPanelViewModel } from '@/features/admin/staffing/components/ApplicantManagementPanel/ApplicantManagementPanelViewModel'
import { ApplicantManagementTable } from '@/features/admin/staffing/components/ApplicantManagementTable'
import { ApplicantManagementTableRowContainer } from '@/features/admin/staffing/components/ApplicantManagementTableRow/ApplicantManagementTableRowContainer'

export interface ApplicantManagementTableContainerProps {
  vm: ApplicantManagementPanelViewModel
}

export const ApplicantManagementTableContainer = observer(
  function ApplicantManagementTableContainer({
    vm,
  }: ApplicantManagementTableContainerProps) {
    return (
      <ApplicantManagementTable
        columns={vm.columns.map((column) => ({
          id: column.id,
          header: column.header,
          align: column.align,
        }))}
        postingId={vm.workspacePosting?.id}
        allSelectedState={match<SelectionState, boolean | 'indeterminate'>(
          vm.selectionState,
          {
            ['AllSelected']: () => true,
            ['NoneSelected']: () => false,
            ['SomeSelected']: () => 'indeterminate',
          },
        )}
        onToggleAll={vm.toggleAllApplicants}
      >
        {vm.items.map((itemVm) => (
          <ApplicantManagementTableRowContainer
            key={itemVm.applicant.userPublicId}
            vm={itemVm}
            columns={vm.columns}
          />
        ))}
      </ApplicantManagementTable>
    )
  },
)
